<fts-special-wizard-modal-content *ngIf="!!specialWizard"
                                  [specialWizard]="specialWizard"
                                  [isUpsell]="specialWizard?.isUpsell"
                                  [upsellType]="specialWizard?.upsellType"
                                  [featuredAreaName]="specialWizard?.featuredAreaName"
                                  [featuredContentName]="specialWizard?.featuredContentName"
                                  (hideModal)="hideModal($event)"></fts-special-wizard-modal-content>
